export default __webpack_public_path__ + "static/media/14-lying-face_1f925.94aba8f3.png";